import { render, staticRenderFns } from "./oll-unit.vue?vue&type=template&id=7ca27bbf&scoped=true&"
import script from "./oll-unit.vue?vue&type=script&lang=js&"
export * from "./oll-unit.vue?vue&type=script&lang=js&"
import style0 from "./oll-unit.vue?vue&type=style&index=0&id=7ca27bbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca27bbf",
  null
  
)

export default component.exports